import LegalShell from "./LegalShell";

export default function MedicalDisclaimer() {
  return (
    <LegalShell title="Medical Disclaimer" lastUpdated="February 2026">
      <p>
        The information provided through the Fitest platform, including the wellness audit, scoring, tier classifications
        (Critical, Exposed, Performing, Elite), and the resulting PDF report, is provided for{" "}
        <strong>educational and informational purposes only</strong>. It is not intended to be a substitute for
        professional medical advice, diagnosis, or treatment.
      </p>

      <h2>Not Medical Advice</h2>
      <p>
        Fitest does not provide medical advice. The Fitest audit is a self-reported lifestyle assessment and not a
        clinical, diagnostic, or therapeutic instrument. Always seek the advice of a qualified physician or other
        suitably qualified healthcare provider with any questions you may have regarding a medical condition. Never
        disregard professional medical advice or delay in seeking it because of something you have read or seen on the
        Platform.
      </p>

      <h2>No Doctor–Patient Relationship</h2>
      <p>
        Use of the Fitest platform does not establish a doctor–patient relationship between you and Leadsopedia Limited
        (trading as Fitest), the Licence Holder issuing the audit, or any other party associated with the Platform.
      </p>

      <h2>Emergency Situations</h2>
      <p>
        If you believe you may have a medical emergency, call your local emergency services or visit the nearest
        accident & emergency department immediately. Do not rely on the Platform in any urgent or emergency situation.
      </p>

      <h2>Personal Responsibility</h2>
      <p>
        Any actions you take based on the audit results — including changes to diet, exercise, sleep, or supplementation
        — are at your own discretion and risk. You are solely responsible for evaluating the suitability of any
        information for your circumstances.
      </p>

      <h2>No Warranty</h2>
      <p>
        The audit, score, and recommendations are provided "as is" without warranty of any kind, either express or
        implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or
        non-infringement. Fitest, Leadsopedia Limited, and any issuing Licence Holder accept no liability for any loss
        or harm arising from reliance on the audit results.
      </p>

      <h2>Acceptance</h2>
      <p>
        By proceeding with the Fitest audit, you confirm that you have read, understood, and accept this Medical
        Disclaimer.
      </p>
    </LegalShell>
  );
}
